const initialState = {
    isLoaded: false,
    web3Instance: null
}

const web3Reducer = (state = initialState, action) => {
    if (action.type === 'WEB3_INITIALIZED'){
        return Object.assign({}, state, {
            isLoaded: true,
            web3Instance: action.payload.web3Instance
        })
    }

    return state
}

export default web3Reducer



// WEBPACK FOOTER //
// ./src/util/web3/web3Reducer.js